import StyledMenu, { Menu, MenuItem } from './styles';

import Icon from '@map/components/Icons';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';
/**
 * useHistory é um hook utilizado para redirecionar para outra pagina.
 */
import { useHistory } from 'react-router-dom';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useModule } from 'views/MapView/hooks';

const Switcher = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { modules, activeModule } = useModule();
  const history = useHistory();
  const [expandedModule, setExpandedModule] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const switchModule = (module) => {
    if (module.tipo_modulo !== 'externo') {
      history.push(module.endereco);
    } else {
      window.location.href = module.endereco;
    }
    setExpandedModule(null);
    handleClose();
  };

  return (
    <StyledMenu>
      <button type="button" className="menu_icon" onClick={handleClick}>
        <Icon i="map-menu" />
      </button>
      <Menu
        className="menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        keepMounted
        open={open}
        onClose={handleClose}
        elevation={3}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: -5,
          horizontal: 'left',
        }}
      >
        <div className="arrow" />
        <h1>Módulos</h1>
        <hr />
        <div className="items">
          {modules &&
            modules.map(
              (module, i) =>
                !module.draft &&
                module.st_publico &&
                module.st_ativo &&
                module.id !== (activeModule ? activeModule.id : 0) && (
                  <MenuItem className="module" key={i}>
                    <div onClick={() => switchModule(module)}>
                      <div>
                        <img src={module.icone} alt="Ícone do módulo" />
                        <h4>{module.titulo}</h4>
                        <Tooltip title="Descrição">
                          <button
                            className="desc-bt"
                            onClick={(e) => {
                              e.stopPropagation();
                              expandedModule && expandedModule === module.id
                                ? setExpandedModule(null)
                                : setExpandedModule(module.id);
                            }}
                          >
                            <Icon i="map-description" />
                          </button>
                        </Tooltip>
                      </div>
                      <div
                        className={`description ${
                          expandedModule && expandedModule === module.id
                            ? 'expanded'
                            : ''
                        }`}
                      >
                        <p>{module.descricao}</p>
                      </div>
                    </div>
                  </MenuItem>
                )
            )}
        </div>
      </Menu>
    </StyledMenu>
  );
};

Switcher.properties = {
  id: 'CPN-HB-MODULES_SWITCHER',
  alias: 'Menu de Módulos',
  description: 'Menu para alternar entre a vissualização de módulos',
};

export default Switcher;
